// Демо-форма подсказок по компаниям.

import helper from "../domain/party";
import createComponent from "../vue";
import objectLink from "./object-link";
import Analytics from "../marketing/analytics";

const $ = window.jQuery;

const STATE = {
    copied: false,
    party: null,
    type: "PARTY",
    value: "",
};

const properties = {
    address() {
        return helper.address(this.party);
    },
    capital() {
        return helper.capital(this.party);
    },
    copyLinkEnabled() {
        return (
            this.party.ogrn &&
            (this.party.branch_type === "MAIN" || this.party.type === "INDIVIDUAL")
        );
    },
    debt() {
        return helper.financeField(this.party, "debt");
    },
    egrulLink() {
        return helper.egrulLink(this.party);
    },
    employeeCount() {
        return helper.employeeCount(this.party);
    },
    expense() {
        return helper.financeField(this.party, "expense");
    },
    fts() {
        return helper.fts(this.party);
    },
    fullname() {
        return helper.fullname(this.party);
    },
    geo() {
        return helper.geo(this.party);
    },
    hasAccurateGeo() {
        return helper.hasAccurateGeo(this.party);
    },
    hasManager() {
        return helper.hasManager(this.party);
    },
    income() {
        return helper.financeField(this.party, "income");
    },
    isIndividual() {
        return helper.isIndividual(this.party);
    },
    isLegal() {
        return helper.isLegal(this.party);
    },
    managerInn() {
        return helper.managerInn(this.party);
    },
    managerName() {
        return helper.managerName(this.party);
    },
    managerTitle() {
        return helper.managerTitle(this.party);
    },
    name() {
        return helper.name(this.party);
    },
    okved() {
        return helper.okved(this.party);
    },
    penalty() {
        return helper.financeField(this.party, "penalty");
    },
    pf() {
        return helper.authority(this.party, "pf");
    },
    registration() {
        return helper.registration(this.party);
    },
    registrationDate() {
        return helper.registrationDate(this.party);
    },
    sif() {
        return helper.authority(this.party, "sif");
    },
    smb() {
        return helper.smb(this.party);
    },
    status() {
        return helper.state(this.party);
    },
    taxSystem() {
        return helper.taxSystem(this.party);
    },
};

const methods = {
    initSuggestions(serviceUrl, token) {
        const el = $(this.$refs.input);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 7,
            onSelect: this.onSelect,
            onSelectNothing: this.onSelectNothing,
        };
        el.suggestions(params);
    },

    onSelect(suggestion) {
        this.value = suggestion.value;
        this.party = suggestion.data;
        this.party.emails = helper.emails(this.party);
        this.party.phones = helper.phones(this.party);
        Analytics.reachGoal("SUG_DEMO_FORM_PARTY");
    },

    onSelectNothing(query) {
        this.value = query;
        this.party = null;
    },

    clear() {
        this.value = "";
        this.party = null;
    },

    copyLink(event) {
        const url = objectLink.buildUrl("party", this.party.ogrn);
        objectLink.copy(url);
        objectLink.showCopied(this);
        event.preventDefault();
    },

    formatFounderName(founder) {
        return helper.founderName(founder);
    },

    formatFounderShare(share) {
        return helper.founderShare(share);
    },
};

function buildConfig(serviceUrl, token) {
    return {
        data() { return STATE; },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
            document.addEventListener("party-change", e => {
                this.clear();
                this.value = e.detail.value;
            });
        },
        computed: properties,
        methods,
    };
}

export default function Suggestions(serviceUrl, token) {
    const partyConfig = buildConfig(serviceUrl, token);

    createComponent(partyConfig, "#party-vue-app");
}
